__turbopack_context__.v({
  "container": "_0C4uzG_container",
  "description": "_0C4uzG_description",
  "icon": "_0C4uzG_icon",
  "label": "_0C4uzG_label",
  "spacer": "_0C4uzG_spacer",
  "status--invalid": "_0C4uzG_status--invalid",
  "status--valid": "_0C4uzG_status--valid",
  "status--warning": "_0C4uzG_status--warning",
  "subtext": "_0C4uzG_subtext",
  "title": "_0C4uzG_title",
});
